import * as React from 'react';
import {
    List, Datagrid,
    SelectInput,
    SelectField, FunctionField, DateField,
    Pagination, EditButton
} from 'react-admin';
import { workerTypeChoices } from '../jobs/utils'
import { workerStatusChoices } from './utils';
import TextCopyField from '../commons/TextCopyField';

const workerFilters = [
    <SelectInput source="type" key="filter_status" label="Type" choices={workerTypeChoices} alwaysOn />,
    <SelectInput source="status" key="filter_status" label="Status" choices={workerStatusChoices} alwaysOn />,
];

const WorkerList = () => {
    return (
        <List
            filters={workerFilters}
            sort={{ field: 'id', order: 'ASC' }}
            perPage={20}
            pagination={<Pagination rowsPerPageOptions={[10, 20, 50, 100]} />}
            mutationMode="pessimistic"
        >
            <Datagrid
                sx={{
                    '& .column-groups': {
                        md: { display: 'none' },
                        lg: { display: 'table-cell' },
                    },
                }}
            >
                <SelectField source="type" choices={workerTypeChoices} />
                <SelectField source="status" choices={workerStatusChoices} />
                <FunctionField label='Ping Time' render={
                    record =>
                        (record.pingTime > 0 ? <DateField source="pingTime" showTime /> : '?')
                }
                />
                <TextCopyField sx={{ fontFamily: 'Monospace' }} label="Key" source="key" />
                <TextCopyField sx={{ fontFamily: 'Monospace' }} label="ID" source="id" />
                <EditButton />
            </Datagrid>
        </List>
    );
};

export default WorkerList;
